import { NgModule } from '@angular/core'

import { RouterModule } from '@angular/router'
import { OverlayModule } from '@angular/cdk/overlay'
import { SharedModule } from '@shared/shared.module'

import { ToolbarComponent } from './toolbar.component'
import { ToolbarSearchComponent, ToolbarSearchResultRowDirective } from './search/toolbar-search.component'
import { ToolbarSearchResultsComponent } from './search/toolbar-search-results.component'
import { ToolbarSearchResultsTriggerDirective } from './search/toolbar-search-results-trigger.directive'
import { NotificationsModule } from './notifications/notifications.module'
import { IntercomComponent } from './intercom/intercom.component'
import { MessengerModule } from '@app/modules/client/messenger/messenger.module'
import { HeaderBannerComponent } from './header-banner/header-banner.component'
import { SosModule } from './sos/sos.module'

@NgModule({
  declarations: [
    ToolbarComponent,
    ToolbarSearchComponent,
    ToolbarSearchResultsComponent,
    ToolbarSearchResultsTriggerDirective,
    ToolbarSearchResultRowDirective,
    IntercomComponent,
    HeaderBannerComponent,
  ],
  imports: [RouterModule, OverlayModule, SharedModule, NotificationsModule, MessengerModule, SosModule],
  exports: [ToolbarComponent, HeaderBannerComponent],
})
export class ToolbarModule {}
